import { createFileRoute } from "@tanstack/react-router";
import PressReleases from "@/pages/PressReleases";

export const Route = createFileRoute("/_app/press-releases/")({
  head: () => ({
    meta: [
      { title: "Press Releases | Byteline" },
      {
        name: "description",
        content:
          "Company announcements, partnerships and funding news submitted to Byteline, published as received.",
      },
      { property: "og:title", content: "Press Releases | Byteline" },
      {
        property: "og:description",
        content:
          "Company announcements, partnerships and funding news submitted to Byteline, published as received.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: PressReleases,
});
